// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EweLNPvL_QkURlMAlWXo{padding-right:12px}`, "",{"version":3,"sources":["webpack://./src/shared/ui/AudioPlayer/ui/AudioWave/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA","sourcesContent":[".wrap {\n  padding-right: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `EweLNPvL_QkURlMAlWXo`
};
export default ___CSS_LOADER_EXPORT___;
